import { FormioInput } from '../../../../types/themeTypes';

export const inputHeight = 60;
const inputIconTransition = 'border-color ease-in-out .15s, color ease-in-out .15s';

export default {
    height: inputHeight,
    iconTransition: inputIconTransition,
} as FormioInput;
